import React from 'react';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import './PaddingComponent.scss';
import CustomTextField from '../../form-controls/custom-text-field/Custom-Text-Field';

const PaddingComponent = (props) => {
  const { formData, setFormData } = props;
  return (
    <div className='padding-component'>
      <div
        className='col-md-3'
        onClick={() =>
          setFormData({
            padding: { ...formData.padding, value: !formData.padding.value },
          })
        }
      >
        <div className='d-flex align-items-center'>
          {formData.padding.value ? (
            <ToggleOnIcon className='toggle-on' fontSize='large' />
          ) : (
            <ToggleOffIcon className='toggle-off' fontSize='large' />
          )}{' '}
          <span>Padding</span>
        </div>
      </div>
      {formData.padding.value && (
        <>
          <div className='row mt-3'>
            <div className='col-md-6'>
              <CustomTextField
                item={formData.top}
                handleInputChange={(e) => {
                  setFormData({ top: e });
                }}
                type='number'
                min={0}
                max={9999}
              />
            </div>
            <div className='col-md-6'>
              <CustomTextField
                item={formData.bottom}
                handleInputChange={(e) => {
                  setFormData({ bottom: e });
                }}
                type='number'
                min={0}
                max={9999}
              />
            </div>
            <div className='col-md-6'>
              <CustomTextField
                item={formData.left}
                handleInputChange={(e) => {
                  setFormData({ left: e });
                }}
                type='number'
                min={0}
                max={9999}
              />
            </div>
            <div className='col-md-6'>
              <CustomTextField
                item={formData.right}
                handleInputChange={(e) => {
                  setFormData({ right: e });
                }}
                type='number'
                min={0}
                max={9999}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaddingComponent;
